module.exports = __webpack_public_path__ + "img/applicationConstruction-jhsj.7668e884.png";